<mat-card class="result-card">
    <mat-card-content>
        <div class="card-header">
            <mat-icon class="warning-icon" svgIcon="attention"></mat-icon>
            <div class="card-title">
                <strong>{{ factor.taskDetail?.description }}: {{ factor.taskDetail?.name }}</strong>
            </div>
        </div>

        <p class="card-description">{{ feedback }}</p>

        <button class="expand-button" (click)="toggleExpand()">
            <mat-icon>{{ isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
            <span>RUBRIC REQUIREMENTS</span>
        </button>

        <div class="expand-content" [@expandCollapse]="expandState">
            <!-- Add your expanding content here -->
            @for (item of factor.taskDetail!.qualitySpecs; track item) {
                <app-rubric-card class="rubric-card" [rubricQualitySpec]="item"></app-rubric-card>
            }
        </div>
    </mat-card-content>
</mat-card>
